import * as React from 'react';
import { useSelector } from 'react-redux';
import defaultBackground from '../Header/assets/background.png';
import { BackgroundContext, TAdfoxLoadPayload, TBackgroundContext } from './context';
import { selectSuburbanRkBackground } from '../../../selectors/countryside';
import { useApplicationContext } from '../../../utils/applicationContext';

export const BackgroundProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const suburbanRkBackground = useSelector(selectSuburbanRkBackground);
  const defaultImageUrl = suburbanRkBackground || defaultBackground;
  const { config } = useApplicationContext();

  const showBackgroundTimeout = config.get<number>('countrysideMainpage.showBackgroundTimeout') || 1500;

  const timer = React.useRef<number | undefined>(undefined);
  const [imageUrl, setImageUrl] = React.useState<string | undefined>(undefined);
  const [label, setLabel] = React.useState<string | undefined>(undefined);
  const [isBackgroundShown, setIsBackgroundShown] = React.useState(false);

  React.useEffect(() => {
    timer.current = window.setTimeout(() => {
      setIsBackgroundShown(true);
    }, showBackgroundTimeout);

    return () => {
      window.clearTimeout(timer.current);
    };
  }, []);

  const onAdfoxLoad = React.useCallback((payload: TAdfoxLoadPayload) => {
    window.clearTimeout(timer.current);
    setImageUrl(payload.bgImageUrl);
    setLabel(payload.label);
    setIsBackgroundShown(true);
  }, []);

  const onAdfoxStub = React.useCallback(() => {
    window.clearTimeout(timer.current);
    setImageUrl(undefined);
    setLabel(undefined);
    setIsBackgroundShown(true);
  }, []);

  const value = React.useMemo<TBackgroundContext>(
    () => ({
      imageUrl,
      defaultImageUrl,
      isBackgroundShown,
      label,
      onAdfoxLoad,
      onAdfoxStub,
    }),
    [imageUrl, defaultImageUrl, isBackgroundShown, label, onAdfoxLoad, onAdfoxStub],
  );

  return <BackgroundContext.Provider value={value}>{children}</BackgroundContext.Provider>;
};
